import React, { Suspense } from 'react'
import { css } from '@emotion/core'
import { colors, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import findLang from '../../global/find-lang'
import NavLink from './NavLink'

const LangPicker = React.lazy(() => import('@fs/zion-lang-picker'))

const linkCss = css`
  &::before {
    content: ' ';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAWlBMVEUAAAB3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3cyECA3AAAAHXRSTlMApeAO+po1/H/uyXcZCvPortXBi04luZ9xVz4EE05v0OMAAACjSURBVBjTZU9JEoMwDJNDQgJZCDuU+v/frJ1OT9WMD14kWVD0zlhrXI8vOuKBjGVm6lo/8nDeNU119aNOSFYlLu8daWYSPiumsAO5Fu7hipd+b+QzWgdDcUkXFE5ODWx4wpqavBpZ+KBGJT7AVQ1boQCYmOcXgFsobsjAJsIJaumkhIOZVwiC2IL8BpglQw+pve5DPkQhB3n9F+5wkYYW7i/+B2iSCWl6HoSJAAAAAElFTkSuQmCC')
      top left no-repeat;
    padding-left: 24px;
    padding-bottom: 1px;
  }
`

const loadingCss = css`
  color: ${colors.text.secondary};
  font-size: 0.875rem;
  line-height: 1.35;
  margin-right: 25px;
  background: transparent;
  border: none;
  font-family: Verdana, Ayuthaya, sans-serif;

  &::before {
    content: '';
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAWlBMVEUAAAB3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3d3cyECA3AAAAHXRSTlMApeAO+po1/H/uyXcZCvPortXBi04luZ9xVz4EE05v0OMAAACjSURBVBjTZU9JEoMwDJNDQgJZCDuU+v/frJ1OT9WMD14kWVD0zlhrXI8vOuKBjGVm6lo/8nDeNU119aNOSFYlLu8daWYSPiumsAO5Fu7hipd+b+QzWgdDcUkXFE5ODWx4wpqavBpZ+KBGJT7AVQ1boQCYmOcXgFsobsjAJsIJaumkhIOZVwiC2IL8BpglQw+pve5DPkQhB3n9F+5wkYYW7i/+B2iSCWl6HoSJAAAAAElFTkSuQmCC')
      top left no-repeat;
    padding-left: 24px;
    padding-bottom: 1px;
  }
`

export default function LanguageLink() {
  const overlay = useOverlay()
  const { t } = useTranslation()
  const langText = findLang(i18n.language, t)
  return (
    <>
      <Suspense fallback={<span css={loadingCss}>{t('common-ui:loading.ellipsis.label', 'Loading...')}</span>}>
        <NavLink text={langText} onClick={overlay.open} css={linkCss} />
        {overlay.isOpen && <LangPicker overlay={overlay} />}
      </Suspense>
    </>
  )
}
